import {
  ArrowRightStartOnRectangleIcon,
  ChevronRightIcon,
} from '@heroicons/react/24/outline';
import { List, ListItem } from '@material-tailwind/react';
import { Link, useLocation } from 'react-router-dom';
import TextWinds from '../../components/common/TextWinds';
import '../../styles/mypage/mypage.css';
import useUserHook from '../../controllers/useUserHook';
import { useState } from 'react';
import { logout } from '../../api/utils/util-func';

const MypageMain = () => {
  const location = useLocation();
  const { user } = useUserHook();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems1: menuItemType[] = [
    // { title: '회원등급', link: '/mypage/rating', color: 'purple5' },
    { title: '수료증', link: '/mypage/certification', color: 'gray6' },
    { title: '보유 포인트', link: '/mypage/point', color: 'purple5' },
    { title: '구매내역', link: '/mypage/purchase', color: 'purple5' },
    // {title:"쿠폰", link:"/mypage/coupon", detail:"10 장", color:"purple5"},
  ];
  const menuItems2: menuItemType[] = [
    { title: '교인인증', link: '/mypage/membership' },
    { title: '뱃지 보기', link: '/mypage/badge' },
    { title: '공지사항', link: '/mypage/notice' },
    // {title:"공지사항", link:"https://jebs-notice.oopy.io/55e90fc4-9893-4189-9c9d-759c138d4e98", type:"_blank"},
    { title: '이벤트', link: '/mypage/event' },
    // {title:"이벤트", link:"https://jebs-notice.oopy.io/b68dae28-f925-44c7-aaeb-ba5e2d12e279", type:"_blank"},
    { title: '고객센터', link: '/mypage/customer' },
    { title: '회원 정보 수정', link: '/mypage/modify' },
    { title: '설정', link: '/mypage/setting' },
  ];

  const getUserGrade = (gradeLevel: number) => {
    switch (gradeLevel) {
      case 1:
        return 'FELLOW';
      case 2:
        return 'PARTNER';
      case 3:
        return 'PARTNER+';
      case 4:
        return 'FAMILY';
      case 5:
        return 'FAMILY+';
      case 6:
        return 'VIP';
      default:
        return '';
    }
  };

  return (
    <section className="flex flex-col gap-y-4 pt-5 lg:gap-y-[30px] lg:px-0 lg:px-5 lg:pb-[54px] lg:pt-[10px] lg:pt-[58px]">
      <div className="mb-[10px] flex flex-col gap-y-[22px] lg:mb-0 lg:gap-y-6">
        {/* <TextWinds type="title_h2" xlType="title_h1">
                    내 정보
                </TextWinds> */}
        <div className="flex items-center gap-4 pl-4">
          <img
            src={process.env.PUBLIC_URL + '/svg/icon/manageStudent.svg'}
            alt="manageStudent"
            className="h-[48px] w-[48px]"
          />
          {/* <Avatar
                        variant="circular"
                        src={process.env.PUBLIC_URL + "/svg/icon-profile.svg"}
                        className="w-18 h-18 bg-gray4"
                        alt="myname"
                    /> */}
          <div>
            <TextWinds type="sub_title01">{user?.name}</TextWinds>
            <TextWinds type="content_body2" color="gray7">
              {user?.uid}
              <br />
              {getUserGrade(user?.gradeLevel)}
            </TextWinds>
          </div>
        </div>
      </div>
      <List className="hidden p-0 lg:block">
        {menuItems1.map((item, index) => (
          <MenuItemComp
            key={index}
            item={item}
            isActive={location.pathname === item.link}
          />
        ))}
        <hr className="my-2 border-blue-gray-50" />
        {menuItems2.map((item, index) => (
          <MenuItemComp
            key={index}
            item={item}
            isActive={location.pathname === item.link}
          />
        ))}

        <ListItem
          className="flex items-center gap-2 px-3 py-4 text-red-500"
          onClick={() => logout()}
        >
          <ArrowRightStartOnRectangleIcon className="h-[22px] w-[22px]" />
          로그아웃
        </ListItem>
      </List>
      {/* <div className="flex flex-wrap gap-1 lg:hidden"> */}
      {isMenuOpen && (
        <div className="mountAnimation grid grid-cols-3 gap-2 lg:hidden">
          {menuItems1.map((item, index) => (
            <MenuItemMiniComp
              key={index}
              item={item}
              isActive={location.pathname === item.link}
            />
          ))}
          {menuItems2.map((item, index) => (
            <MenuItemMiniComp
              key={index}
              item={item}
              isActive={location.pathname === item.link}
            />
          ))}
        </div>
      )}
      <div
        className="block cursor-pointer border p-2 text-center text-xs hover:bg-gray2 lg:hidden"
        onClick={() => setIsMenuOpen(!isMenuOpen)}
      >
        {isMenuOpen ? '메뉴 닫기' : '메뉴 더보기'}
      </div>
      <div
        className="block cursor-pointer border p-2 text-center text-xs hover:bg-gray2 lg:hidden"
        onClick={() => logout()}
      >
        로그아웃
      </div>
      <hr className="my-2 border-blue-gray-50 lg:hidden" />
    </section>
  );
};

type menuItemType = {
  title: string;
  link: string;
  detail?: string;
  color?: string;
  type?: '_blank' | undefined;
};

const MenuItemComp = ({
  item,
  isActive,
}: {
  item: menuItemType;
  isActive: boolean;
}) => {
  return (
    <Link to={item.link} target={item.type}>
      <ListItem
        className={`justify-between rounded px-0 py-4 text-black lg:pl-3 lg:pr-6 lg:hover:bg-purple0 ${
          isActive ? 'mypage-on' : ''
        }`}
      >
        {item.title}
        <div className="flex gap-2">
          <TextWinds type="content_body2" color={item.color}>
            {item.detail}
          </TextWinds>
          <ChevronRightIcon className="h-[22px] w-[22px]" />
        </div>
      </ListItem>
    </Link>
  );
};

const MenuItemMiniComp = ({
  item,
  isActive,
}: {
  item: menuItemType;
  isActive: boolean;
}) => {
  return (
    <Link
      to={item.link}
      className={`box-border inline w-full rounded-lg p-3 text-center text-xs hover:bg-gray-100 ${
        isActive ? 'mypage-on' : ''
      }`}
    >
      {item.title}
    </Link>
  );
};

export default MypageMain;
